<template>
   <div class="duration-popup">
     <PopupHeader title="Długość pobytu" icon="couple" @close="close" />
     <RadioList class="duration-popup__body"
     :value="value.range" :options="value.ranges" @input="input" />
     <PopupFooter @select="$emit('input', value)" selectAll="" clear="" />
   </div>
 </template>
 
<script>
import Vue from 'vue'
import Component from 'vue-class-component'
 
import PopupFooter from './PopupFooter.vue'
import PopupHeader from './PopupHeader.vue'
 
import AutoCloseMixin from '@/components/AutoCloseMixin'
import BodyFreezerMixin from '@/components/BodyFreezerMixin'
import RadioList from '@/components/RadioList.vue' 

 @Component({
   mixins: [
     AutoCloseMixin,
     BodyFreezerMixin,
   ],
   components: {
     PopupHeader,
     PopupFooter,
     RadioList,
   },
   props: {
     value: {
       type: Object,
       required: true,
     },
   },
 })
export default class Duration extends Vue {
   created () {
     this.freezeBody()
   }
  
   destroyed () {
     this.unfreezBody()
   }

   input (value) {
     this.value.range = value
   }
 }
</script>
 
 <style lang="scss">
 @import '../mobile-popup.scss';
 
 .duration-popup {
   @include mobile-popup(white, #005ca9);
 
   &__body {
     @include mobile-popup__body(black, white);
   }
 }
 </style>
 


// WEBPACK FOOTER //
// src/components/search/fields/DurationPopup.vue